<template>
  <div>
    <div class="notification is-light">
      {{ instrumentState.descItem }}
    </div>

    <!-- Select Faixa -->
    <div class="level">
      <div class="level-left">
        <div class="field">
          <label class="label">Faixa</label>
          <div class="control">
            <div class="select">
              <select
                v-model="faixaSelecionada"
              >
                <option
                  v-for="(faixa, i) in faixas"
                  :value="faixa.CodigoFaixaModelo"
                >{{faixa.DescFaixa}}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- seta mudar faixa -->
        <!--
        <span>&nbsp;</span>
        <div class="field has-addons">
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="icon ion-md-arrow-dropleft"></i>
              </span>
            </a>
          </p>
          <p class="control">
            <a class="button">
              <span class="icon is-small">
                <i class="icon ion-md-arrow-dropright"></i>
              </span>
            </a>
          </p>
        </div>-->
      </div>
    </div>

    <!-- Selct tempo -->
    <div class="level">
      <div class="level-left">
        <div class="field">
          <label class="label">Dados até</label>
          <div class="control">
            <div class="select is-small">
              <select
                v-model="eventoSelecionado"
              >
                <option>Agora</option>
                <option
                  v-for="(evento, i) in eventosDaFaixa"
                  :key="evento.data"
                  :value="evento.data"
                >{{evento.tipo}} - {{evento.dataHuman}}</option> 
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="columns is-multiline">
      <div class="tabs is-hidden-tablet" style="margin-bottom: 0px;">
        <ul>
          <li v-bind:class="graficoVisivelMobile === 'faixa' ? 'is-active' : ''">
            <a @click="graficoVisivelMobile = 'faixa'">Faixa</a>
          </li>
          <li v-bind:class="graficoVisivelMobile === 'tendencia' ? 'is-active' : ''">
            <a @click="graficoVisivelMobile = 'tendencia'">Tendência</a>
          </li>
        </ul>
      </div>
      <div class="column is-6" v-show="!ehBulmaTablet || graficoVisivelMobile === 'faixa'">

        <article class="message is-white">
          <div class="message-header">

            <p class="is-hidden-mobile has-text-info">Faixa</p>

            <div class="">

              <span>
                <input type="checkbox" name="switchExibirLegendas" class="switch is-rounded" :checked="exibirLegendas">
                <label style="font-size: 10px;padding-top: 0.3rem;" @click="exibirLegendas = !exibirLegendas" for="switchExibirLegendas">Legenda</label>
              </span> &nbsp;

              <span v-if="podeTerRespFreq">
                <input type="checkbox" name="switchRespFreq" class="switch is-rounded" :checked="respFreq">
                <!-- <label v-if="!respFreq" style="font-size: 10px;" @click="respFreq = !respFreq" for="switchRespFreq">Resposta em frequência</label> -->
                <label style="font-size: 10px;padding-top: 0.3rem;" @click="respFreq = !respFreq" for="switchRespFreq">Resp. Freq.</label>
              </span>

              <span v-if="podeTerRespFreq && respFreq">
                <input type="checkbox" name="switchRespFreqLogX" class="switch is-rounded" :checked="respFreqLogX">
                <label style="font-size: 10px;padding-top: 0.3rem;" @click="respFreqLogX = !respFreqLogX" for="switchRespFreqLogX">Escala log</label>
              </span>

              
            </div>

            <span class="icon has-text-info abre-ajuda" @click="instrumentState.modals.helpFaixa = true"> <i class="fas fa-question-circle"></i></span>
            
          </div>
          <div class="message-body" style="padding: 0px !important">
            <div ref="grafico-faixa-container" style="height: 300px;"></div>
          </div>
        </article>

      </div>
      <div class="column is-6" v-show="!ehBulmaTablet || graficoVisivelMobile === 'tendencia'">
        <article class="message is-white">
          <div class="message-header">
            <p class="is-hidden-mobile has-text-info">Tendência</p>


            <!-- seta mudar ponto -->
            <p class="control">
            <span class="field has-addons" style="margin: -6px !important;">

              <span for="histSeriePontoSel" style="font-size: 10px;padding-top: 0.6rem;font-weight: 600;padding-right: 6px;">Ponto:</span>

              <span class="select is-small">
                <select name="histSeriePontoSel" ref="histSeriePontoSel" @change="histSeriePontoSelHandler">
                  <optgroup v-for="nomeSerie in nomesDasSeries" :label="nomeSerie">
                    <option v-for="ponto in pontosExistenteParaCadaSerie[nomeSerie]" :value="ponto" :label="''+ponto+' '+prefixoUnidade">{{ponto}} {{prefixoUnidade}}</option>
                  </optgroup>
                </select>
              </span>
              &nbsp;
              <span class="buttons has-addons">
                <span class="button is-small" :disabled="ehPrimeiroPontoDoHistorico" @click="histSeriePontoAnteriorSelHandler" style="padding-top: 0.6rem;">
                  <span class="icon is-small">
                    <i class="icon fas fa-chevron-left"></i>
                  </span>
                </span>
                <span class="button is-small" :disabled="ehUltimoPontoDoHistorico" @click="histSerieProximoPontoSelHandler" style="padding-top: 0.6rem;">
                  <span class="icon is-small">
                    <i class="icon fas fa-chevron-right"></i>
                  </span>
                </span>
              </span>
            </span>
            </p>



            <span class="icon has-text-info abre-ajuda" @click="instrumentState.modals.helpTendencia = true"> <i class="fas fa-question-circle"></i> </span>




          </div>
          <div class="message-body" style="padding: 0px !important">
            <div ref="grafico-historico-container" style="height: 300px;"></div>
          </div>
        </article>
        
      </div>
    </div>

    <!-- Linha Regras e resultados-->

    <article class="message is-white">
      <div class="columns">
        <div class="column">
          <article class="message is-white" style="border: 0px;box-shadow: none;">
            <div class="message-header">
              <p class="has-text-info">Regra de Decisão</p>
              <span class="icon has-text-info abre-ajuda" @click="instrumentState.modals.helpRegra = true"> <i class="fas fa-question-circle"></i></span>
            </div>
            <div class="message-body" style="padding-top: 4px !important;">

              <div class="notification" style="padding: 6px;">
                <p>Resultado <span class="tag is-success">Conforme</span> se <span style="font-size: 0.8em;font-weight: bold;"><span v-if="!analiseFaixa.aplicarCorrecao">(|Erro| + U)</span><span v-if="analiseFaixa.aplicarCorrecao">U</span> × Fator ≤ EMA</span></p>
                <p>Resultado <span class="tag is-danger">Não Conforme</span> se <span style="font-size: 0.8em;font-weight: bold;"><span v-if="!analiseFaixa.aplicarCorrecao">(|Erro| + U)</span><span v-if="analiseFaixa.aplicarCorrecao">U</span> × Fator > EMA</span></p>
              </div>

              <div class="field">
                <span>
                  <input type="checkbox" v-model="analiseFaixa.aplicarCorrecao" name="aplicarCorrecao" class="switch is-rounded is-link" :checked="exibirLegendas">
                  <label for="aplicarCorrecao" @click="analiseFaixa.aplicarCorrecao = !analiseFaixa.aplicarCorrecao">Corrigir</label>
                </span>
              </div>
              <div class="field">
                <label class="label">Fator</label>              
                <div class="control">
                  <input
                    style="width: 100px;"
                    class="input"
                    type="number"
                    max="10"
                    min="1"
                    placeholder="Fator"
                    v-model="analiseFaixa.fatorMultiplicativo"
                  >
                </div>
              </div>

              <div class="field">
                <label class="label">EMA</label>
                <div class="control">
                  <span class="select">
                    <select v-model="analiseFaixa.lhs">
                      <option
                        v-for="(analise, i) in analisesDisponiveis"
                        :value="analise.nome"
                      >{{analise.desc}}</option>
                    </select>
                  </span>
                </div>
              </div>

              <div class="notification" v-if="analiseFaixa.lhs === 'tol'" style="padding: 6px;">
                <label class="label">Tolerância</label>
                <div class="field has-addons has-addons-centered">
                  <p class="control">
                    <input class="input is-size-7" min="0" type="number" placeholder="" v-model="analiseFaixa.tolVal">
                  </p>
                  <p class="control is-size-7">
                    <span class="select">
                      <select v-model="analiseFaixa.tolUnidade">
                        <option>%</option>
                        <option>ppm</option>
                      </select>
                    </span>
                  </p>
                  <p class="control">
                    <a class="button is-static is-size-7">+</a>
                  </p>
                  <p class="control">
                    <input class="input is-size-7" min="0" type="number" placeholder="" v-model="analiseFaixa.tolValNaUnidade">
                  </p>
                  <p class="control" v-if="prefixoUnidade !== ''">
                    <a class="button is-static is-size-7">{{prefixoUnidade}}</a>
                  </p>
                </div>
              </div>

              <div class="field" v-if="instrumentState.usuarioTemAdminRole">
                <p class="control">
                  <a class="button is-small is-link" @click="eventoSelecionado === 'Agora' ? instrumentState.modals.confirmaGravaConfFormVisivel = true : ''" :disabled="eventoSelecionado !== 'Agora'">
                    <!-- <span class="icon is-medium is-left">
                      <i class="fas fa-plus"></i>
                    </span> -->
                    <span>Gravar configurações</span>
                  </a>
                </p>
                
                <br>
                <div v-if="observacaoFaixa" class="card is-shadowless">
                  <div>{{observacaoFaixa.observacao}}</div>
                  <small>
                    <span class="has-text-link">{{observacaoFaixa.autor}}</span> · <span>{{observacaoFaixa.data}}</span>
                  </small>
                </div>

              </div>

              <!-- #Config Analise -->
              <div class="modal modal-fx-fadeInScale" v-bind:class="instrumentState.modals.confirmaGravaConfFormVisivel ? 'is-active' : ''">
                <div class="modal-background"></div>
                <div class="modal-content is-right">
                  <div class="box">
                    <h6 class="title is-6">Confirma a alteração da análise deste instrumento?</h6>

                    <div class="field has-addons">
                      <div class="field-body">
                        <div class="field">
                          <div class="control">
                            <textarea v-model="novaConfObservacao" class="textarea" placeholder="Observação" autofocus=""></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="field">
                      <input type="checkbox" name="switchConfigUpdateTodasAsFaixas" class="switch is-rounded is-link" :checked="configUpdateTodasAsFaixas">
                      <label style="" @click="configUpdateTodasAsFaixas = !configUpdateTodasAsFaixas" for="switchConfigUpdateTodasAsFaixas">
                        Aplicar à todas as faixas
                      </label>
                    </div>

                    
                    <div class="">
                      <a class="button is-light" @click="novaConfObservacao = '';instrumentState.modals.confirmaGravaConfFormVisivel = false">
                        Cancelar
                      </a>
                      <a class="button is-link" @click="gravaConfHandler">
                        Confirmar
                      </a>
                    </div>
                    

                  </div>
                </div>
                <button class="modal-close is-large" aria-label="close" @click="novaConfObservacao = '';instrumentState.modals.confirmaGravaConfFormVisivel = false"></button>
              </div>
              <!-- /Config Analise -->

            </div>
          </article>
        </div>
        <div class="is-divider-vertical" style="padding: 0px !important;margin: 0px !important"></div>
        <div class="column">
          <article class="message is-white" style="border: 0px;box-shadow: none;margin-bottom: 0px;">
            <div class="message-header">
              <p class="has-text-info">Fórmulas e Aplicação</p>
              <span class="icon has-text-info abre-ajuda" @click="instrumentState.modals.helpFormulas = true"> <i class="fas fa-question-circle"></i></span>
            </div>
            <div class="message-body">


              <div class="field">
                <p class="control has-icons-right">
                  <input
                    class="input"
                    type="number"
                    placeholder="Indicação do instrumento"
                    v-model="valorDeTeste"
                  >                    
                  <span class="icon is-right" style="padding-right: 12px;">
                    <span v-if="prefixoUnidade !== ''">{{ prefixoUnidade }}</span>
                  </span>
                </p>
              </div>



                <!-- Resultados do ponto -->
                <article class="media" v-for="(resultado, resultado_i) in resultadosPontoTeste" style="margin-top: 0px;">
                  <div class="media-left">
                    <i class="fa fa-circle" v-bind:style="{ color: resultado[0] }"></i>
                  </div>
                  <div class="media-content">
                    <div class="content">
                      <p style="font-size: 0.9em;line-height: 22px;">

                        <span>{{ resultado[1] }}:</span>
                        <span v-if="!!valorDeTeste"> {{textoValorCorrigido}} {{ resultado2fmt[resultado_i] }} {{ prefixoUnidadeRes }}</span>
                        <span v-if="!valorDeTeste">-</span>

                        
                      </p>
                    </div>
                    <nav class="level is-mobile">
                      <div class="level-left">
                        <a class="level-item">
                        </a>
                      </div>
                    </nav>
                  </div>
                  <div v-if="analiseFaixa.aplicarCorrecao || ehNovaExatidao" class="media-right">

                    <div class="dropdown">
                      <div class="dropdown-trigger">
                        <button class="button is-small" aria-haspopup="true" aria-controls="" @click="formulaDropDown">
                          equações
                        </button>
                      </div>
                      <!-- popover -->
                      <div class="dropdown-menu" id="" role="menu" style="left: -240px;top: 5px;width: 250px;">
                        <div class="dropdown-content">
                          <div class="dropdown-item">

                            <h6 class="title is-6 has-text-info" style="font-weight: 100;">Fórmulas</h6>

                              <p v-if="prefixoUnidadeRes.length">
                                Resultados em {{prefixoUnidadeRes}}
                              </p>
                              <br>
                              
                              <input class="input" style="width: 80px;" v-if="formatoFormula === 'excel'" placeholder="Nome da célula" v-model="nomeCelula">
                              

                              <div v-if="ehNovaExatidao">
                                <p class="has-text-info" style="font-weight: 100;">Nova Exatidão:</p>
                                <pre class="formula-pre">{{ textoInc[resultado_i] }}</pre>
                              </div>

                              <div>
                                <p class="has-text-info" style="font-weight: 100;">Correção:</p>

                                <div v-if="analiseFaixa.aplicarCorrecao">
                                  <pre class="formula-pre">{{ textoCorr[resultado_i] }}</pre>
                                </div>
                                <div v-if="!analiseFaixa.aplicarCorrecao">
                                  <p class="" style="font-weight: 100;">Sem correção.</p>
                                </div>
                              </div>

                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </article>

            </div>
          </article>
          <pre v-if="analiseNotas" v-html="analiseNotas"></pre>
          
        </div>
      </div>
    </article>


    <!-- Tabela -->

    <article class="message is-white">
      <div class="columns">
        <div class="column">
          <article class="message is-white" style="border: 0px;box-shadow: none;">
            <div class="message-header">
              <p class="has-text-info">Dados e Resultados</p>
              <span class="icon has-text-info abre-ajuda" @click="instrumentState.modals.helpDados = true"> <i class="fas fa-question-circle"></i></span>
            </div>
            <div class="message-body">

              <div class="level-item has-text-centered">
                <table v-if="resultadoAnalisesFlattenDeep.length" class="dados-e-resultados table is-fullwidth is-hoverable" style="font-size: 0.9em;">
                  <thead>
                    <tr class="row header">
                      <th v-if="nSeries > 1" class="cell">Série</th>
                      <th class="cell">Ponto {{ prefixoUnidadeParentesesY }}</th>
                      <th class="cell">Erro {{ prefixoUnidadeParentesesY }}</th>
                      <th class="cell">U {{ prefixoUnidadeParentesesY }}</th>
                      <th class="cell">EMA {{ prefixoUnidadeParentesesY }}</th>
                      <th class="cell">Conformidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in dadosTabela" class="row">
                      <td v-if="nSeries > 1" class="cell has-text-weight-semibold" data-title="Série">{{r.nomeSerie}}</td>
                      <td class="cell" data-title="Ponto">{{r.ValorDoInstrumento}}</td>
                      <td class="cell" data-title="Erro">{{r.ResultadoMedicao}}</td>
                      <td class="cell" data-title="U">{{r.IncertExpandidaUsada}}</td>
                      <td class="cell" data-title="EMA">{{r.tol}}</td>
                      <td class="cell" data-title="Conformidade">
                        <span v-if="r.pontoConforme" class="tag is-success" style="max-width: 120px;">Conforme</span>
                        <span v-if="!r.pontoConforme" class="tag is-danger" style="max-width: 120px;">Não Conforme</span>
                      </td>
                      
                    </tr>
                  </tbody>
                </table>

              </div>


            </div>
          </article>
        </div>
      </div>
    </article>

  </div>

</template>

<script>

import {fnSignformatter,
fnHideOnClickOutside,
fnRegreArray,
fnPegaDataUTCNum,
//fnTextoEntreTags,
//fnFmtData,
//fnCampoValidoParaExibicao,
//fnDescItem,
//fnPegaStatus,
//fnPegaStatusChecagem,
//fnQueryInstIdData,
//fnConfigPeriodicidade
} from '../fn'
import SI from 'si-tools'

import {Highcharts, highchartsColors} from '../highchartsOptions'
import moment from '../momentLocale'
import regressao from '../regressao'

export default {
  props: ['store'],
  watch: {
    'winSize.w': function() {
      this.winSizeChangeHandler()
    },
    'graficoVisivelMobile': function(val) {
      this.$nextTick(() => {
        if (val === 'faixa') {
          this.chart.reflow()
        } else {
          this.chartHist.reflow()
        }
      })
    },
    'histPontoSel': function() {
      //this.atualizarGraficoHistorico()
    },
    'histSerieSel': function() {
      //this.atualizarGraficoHistorico()
    },
    'mudancaDeHist': function() {
      this.atualizarGraficoHistorico()
    },
    'eventoSelecionado': function() {
      if (this.eventoSelecionado !== 'Agora') {
        var horaEvento = moment(this.eventoSelecionado).format('DD-MM-YYYY-HH-mm-ss')
        //this.$router.push({ query: { ...this.$route.query, evento: horaEvento }}).catch(err => {})
        this.$router.push({ query: { faixa: this.$route.query.faixa, evento: horaEvento }}).catch(err => {})
      } else {
        this.$router.push({query: {faixa: this.$route.query.faixa}}).catch(err => {})
      }
      this.executaAnalise({analiseDoUsuario: false})
    },
    'faixas': function () {
      this.selecionaFaixaPadrao()
    },
    'instrumentState.data.analise': {
      handler: function (newVal, oldVal) {
        this.executaAnalise({analiseDoUsuario: false})
      },
      deep: true
    },
    'respFreq': function() {this.atualizarGrafico()},
    'respFreqLogX': function() {this.atualizarGrafico()},
    analiseFaixa: {
      handler: function (newVal, oldVal) {
        if (this.analiseFaixa.tolVal === '' || this.analiseFaixa.tolUnidade === '') {
          return
        }
        this.executaAnalise({analiseDoUsuario: true})
      },
      deep: true
    },
    'faixaSelecionada': function () {
      this.histSerieSel = this.seriesFaixa[0].nomeSerie
      this.histPontoSel = this.seriesFaixa[0].data.Valor[0]

      //this.$router.push({query: { ...this.$route.query, faixa: this.faixaSelecionada}}).catch(err => {})
      this.$router.push({query: { evento: this.$route.query.evento, faixa: this.faixaSelecionada}}).catch(err => {})
      //this.atualizarGraficoHistorico()
      this.executaAnalise({analiseDoUsuario: false})
    },
    'exibirLegendas': function() {
      this.chart.legend.update({
        enabled: this.exibirLegendas
      })
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (!to.query.faixa) return
    if (to.query.faixa !== from.query.faixa) {
      this.faixaSelecionada = ''+to.query.faixa
      var temEventoSel = this.eventosDaFaixa.filter((item) => item.data === this.eventoSelecionado).length
      if (!temEventoSel) {
        this.eventoSelecionado = 'Agora'
      }
    }
    next()
  },
  data () {

    return {
      instrumentState: this.store || INSTRUMENT_STORE.state,
      analiseFaixa: {},
      faixaSelecionada: null,
      chart: null,
      chartHist: null,
      exibirLegendas: false,
      respFreq: false,
      respFreqLogX: false,
      seriesColors: highchartsColors,
      dadosFaixa: null, 
      resultadoAnalises: null,
      eventoSelecionado: null,
      histSerieSel: null,
      histPontoSel: null,
      toleranciaCalculada: null,
      valorDeTeste: null,
      graficoVisivelMobile: 'faixa',  //'tendencia'
      winSize: WIN_SIZE,
      ehBulmaTablet: undefined,
      
      exibirFormulas: false,
      analiseNotas: null,
      formatoFormula: 'excel', // al
      nomeCelula: 'A1',
      configUpdateTodasAsFaixas: false,
      novaConfObservacao: ''
    };
  },
  created () {
    if (this.$route.query.evento) {
      this.eventoSelecionado = (moment(this.$route.query.evento, 'DD-MM-YYYY-HH-mm-ss').unix())*1000
    } else {
      this.eventoSelecionado = 'Agora'
    }
  },
  mounted () {
    this.selecionaFaixaPadrao()
    this.criarGrafico()
    this.criarGraficoHist()
    this.winSizeChangeHandler()
  },
  methods: {
    gravaConfHandler () {
      var obj = {
        analise: {}
      }
      var timestamp = Date.now()
      var analiseFaixa = _.cloneDeep(this.analiseFaixa)

      
      if (analiseFaixa.lhs !== 'tol') {
        delete analiseFaixa.tolUnidade
        delete analiseFaixa.tolVal
        delete analiseFaixa.tolVal
        delete analiseFaixa.tolValNaUnidade
      }

      if (this.configUpdateTodasAsFaixas) {
        obj.analise.global = analiseFaixa
        obj.analise.global.timestamp = timestamp
      } else {
        obj.analise[this.$route.query.faixa] = analiseFaixa
        obj.analise[this.$route.query.faixa].timestamp = timestamp
      }      
      
      obj['_id'] = ''+this.instrumentState.data.inst._id+'_config_'+timestamp
      obj['autor'] = this.instrumentState.userCtx['name']
      obj['timestamp'] = timestamp
      obj['observacao'] = !!this.novaConfObservacao.length ? this.novaConfObservacao : null
      obj['type'] = 'config_'+this.instrumentState.data.inst._id
      
      this.instrumentState.db.put(obj)
      .then( (response) => {
        this.instrumentState.modals.confirmaGravaConfFormVisivel = false
        this.novaConfObservacao = ''
        this.$toasted.show('Configuração gravada com sucesso.', {icon: 'fa-check-circle'})
      })
      .catch( (err) => {
        this.$toasted.show('Erro ao gravar configuração.', {icon: 'fa-exclamation-triangle'})
      })
      .finally( () => {

      })
    },
    /**
    
    metodos para resultados do ponto de teste

    */
    formulaDropDown (e) {
      var tgt = e.target.closest('.dropdown')
      tgt.classList.add('is-active')
      fnHideOnClickOutside(tgt)

    },
    pegaTextoRegressaoParaTipo (tipoReg, nomeSerie) {
      const serie = _.find(this.equacaoResultadoAnalises, {nomeSerie: nomeSerie})
      var texto = serie[tipoReg].termosRegressao
      if (this.formatoFormula === 'al') {
        
        let prefVal = SI.parse('1'+this.prefixo).number
        
        //let valPrefixoFmt = ((prefVal === 1) || !prefVal) ? null : '*'+prefVal.toExponential()

        var res = texto.formula.replace(/\n/g,'').replace(/ /g,'').replace(/se/g,'if').replace(/x/g,'leitura')

        res = res.replace(/[0-9]*\.?\,?[0-9]+([eE][-+]?[0-9]+)?/g, (match, contents, offset, input_string) => {
           return (parseFloat(match.replace(',','.'))*prefVal).toExponential(2)
        })

        //console.log(res)
        return res
        
      }
      return '='+texto.formula.replace(/x/g, this.nomeCelula.length ? this.nomeCelula : 'A1')
    },

    /**
    
    metodos para grafico de historico

    */
    winSizeChangeHandler () {
      if (this.winSize.w <= 768) {
        this.ehBulmaTablet = true
      } else {
        this.ehBulmaTablet = false
      }
    },
    criarGraficoHist () {
      var prefixoUnidade = this.prefixoUnidade
      var el = this.$refs['grafico-historico-container']

      this.chartHist = Highcharts.chart(el, {
        exporting: {
            enabled: false
        },
        chart: {
          zoomType: 'xy'
        },
        credits: {
          enabled: false
        },
        title: {
          text: '...'
        },
        subtitle: {
          text: ' '
        },
        xAxis: {
          type: 'datetime',
          /*dateTimeLabelFormats: {
            month: '%b/%Y',
            year: '%b/%Y'
          },*/
          //tickInterval: this.periodicidade,
          //tickInterval: 3600 * 1000 * 24 * 30 * 12,
          //tickPositions: this.tickPositionsComp,
          title: {
            text: 'Data'
          }
        },
        legend: {
          enabled: this.exibirLegendas || false,
          itemMarginTop: 3,
          itemMarginBottom: 3,
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          layout: 'horizontal',
          floating: false,
          align: 'right',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
          shadow: false,
          navigation: {
            activeColor: '#3E576F',
            animation: true,
            arrowSize: 12,
            inactiveColor: '#CCC',
            style: {
              fontWeight: 'bold',
              color: '#333',
              fontSize: '12px'
            }
          }

        },
        tooltip: {
          enabled: false
          /*pointFormatter () { return pointformatter(this, prefixoUnidade) },
          headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
          xDateFormat: '%d/%m/%Y',*/
        }
      })
      this.chartHist.addSeries(this.serieHist)
      this.chartHist.addSeries(this.serieIncertezaHist)
      this.chartHist.addSeries(this.serieTolHist)

    },
    atualizarGraficoHistorico () {
      if (this.chartHist.title) {
        this.chartHist.title.update({
          text: this.tituloHist
        })
      }

      if (this.chartHist.subtitle) {
        this.chartHist.subtitle.update({
          text: this.ultimoCertFxSel.certificado
        })
      }

      this.chartHist.yAxis[0].setTitle({
          text: 'Erro ' + this.prefixoUnidadeParenteses
      });
      
      const animarGrafico = false
      
      this.chartHist.series[0].setData(this.serieHist.data, animarGrafico)
      
      this.chartHist.series[1].setData(this.serieIncertezaHist.data, animarGrafico)
      
      this.chartHist.series[2].setData(this.serieTolHist.data, animarGrafico)

      this.chartHist.xAxis[0].update({
        min: null,
        max: null
      })
      this.chartHist.redraw()
    },
    histSeriePontoSelHandler () {
      var el = this.$refs['histSeriePontoSel']
      var selectedOption = el.selectedOptions[0]
      this.histSerieSel = selectedOption.parentElement.label
      this.histPontoSel = selectedOption.value
    },
    histSerieProximoPontoSelHandler () {
      var el = this.$refs['histSeriePontoSel']
      if (el.selectedIndex < el.length-1) {
        el.selectedIndex = el.selectedIndex+1
        this.histSeriePontoSelHandler()
      }
    },
    histSeriePontoAnteriorSelHandler () {
      var el = this.$refs['histSeriePontoSel']
      if (el.selectedIndex > 0) {
        el.selectedIndex = el.selectedIndex-1
        this.histSeriePontoSelHandler()
      }
    },

    /**
    
    metodos para grafico da faixa

    */
    ajustarArea (res) {
      if (res.data.length === 1) {
        res.data.push([
          res.data[0][0],
          res.data[0][1],
          res.data[0][2]
        ])
        res.data[0][0] = res.data[0][0] * 0.99
        res.data[1][0] = res.data[1][0] * 1.01
      }
    },
    criarGrafico () {
      var el = this.$refs['grafico-faixa-container']
      /* 
      Curva da faixa
      */
      var prefixoUnidade = this.prefixoUnidade
      this.chart = Highcharts.chart(el, {
        exporting: {
            enabled: false
        },
        title: {
          text: this.titulo
        },
        subtitle: {
          text: ' '
        },        
        chart: {
          zoomType: 'xy'
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: this.exibirLegendas || false,
          itemMarginTop: 3,
          itemMarginBottom: 3,
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          layout: 'horizontal',
          floating: false,
          align: 'right',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
          shadow: false,
          navigation: {
            activeColor: '#3E576F',
            animation: true,
            arrowSize: 12,
            inactiveColor: '#CCC',
            style: {
                fontWeight: 'bold',
                color: '#333',
                fontSize: '12px'
            }
          }

        },
        tooltip: {
          enabled: false
          /*pointFormatter () { return pointformatter(this, prefixoUnidade) },
          headerFormat: '<span style="font-size: 10px">{point.key} '+prefixoUnidade+'</span><br/>'*/
        }
      })


    },
    removerSeries () {
      for (var i = this.chart.series.length - 1; i >= 0; i--) {
        this.chart.series[i].remove(false)
      }
    },
    atualizarGrafico () {
      
      if (this.chart.title) {
        this.chart.title.update({
          text: this.titulo
        })
      }

      if (this.chart.subtitle) {
        this.chart.subtitle.update({
          text: this.ultimoCertFxSel.certificado + ' de ' + this.dataFmt
        })
      }

      this.chart.yAxis[0].setTitle({
        text: 'Erro ' + this.prefixoUnidadeParentesesY
      });

      
      this.chart.xAxis[0].setTitle({
        text: 'Ponto ' + this.prefixoUnidadeParentesesX
      });

      var nSeriesNoGrafico = this.chart.series.length
      var series = this.flattenSeries
      
      // Faz com que o grafico nao seja animado enquanto
      // as series são adicionadas.
      // Isto evita que o grafico nao anime nunca
      // quando tem varias series e aumenta a performance,
      // pois a animaçao nao é executada diversas vezes
      const animarGrafico = false
      if (series.length !== nSeriesNoGrafico) {
      
        this.removerSeries()
        for (var i = 0; i < series.length; i++) {
          this.chart.addSeries(series[i], animarGrafico)
        }
      
      } else {

        for (var i = 0; i < series.length; i++) {
          
          // Atualiza nome e label da serie
          if(series[i].name !== this.chart.series[i].name) {
            this.chart.series[i].update({
              name: series[i].name
            })
          }
          
          this.chart.series[i].setData(
            series[i].data, animarGrafico
          )
        }

      }

      this.chart.xAxis[0].update({
        min: null,
        max: null,
        type: (this.respFreqLogX && this.podeTerRespFreq && this.respFreq) ? 'logarithmic' : null
      })
      this.chart.redraw()
    },

    /**
    
    outros metodos

    */

    executaAnalise (arg) {
      var ana
      //console.log(this.instrumentStateDataEventoSel, this.faixaSelecionada, this.analiseFaixa)
      let analiseFaixa = _.clone(this.analiseFaixa)
      
      // evita bug do zero a direita
      if (analiseFaixa.tolVal !== undefined || analiseFaixa.tolValNaUnidade !== undefined) {
        analiseFaixa.tolVal = analiseFaixa.tolVal.toString()
        analiseFaixa.tolValNaUnidade = analiseFaixa.tolValNaUnidade.toString()
      }
      if (arg.analiseDoUsuario) {
        ana = new this.instrumentState.Analises(this.instrumentStateDataEventoSel, this.faixaSelecionada, analiseFaixa)
      } else {
        ana = new this.instrumentState.Analises(this.instrumentStateDataEventoSel, this.faixaSelecionada)
        this.analiseFaixa = _.clone(ana.analiseFaixa)
        // retorna aqui, pois ao definir `analiseFaixa`, esta função será chamada novamente
        // com o argumento arg.analiseDoUsuario verdadeiro
        return
      }
      ana.executa()
      this.dadosFaixa = ana.dadosFaixa
      this.resultadoAnalises = ana.resultadoAnalises
      this.toleranciaCalculada = ana.toleranciaCalculada
      this.analiseNotas = ana.analiseNotas
      this.atualizarGrafico()
      this.atualizarGraficoHistorico()
    },
    selecionaFaixaPadrao () {
      if (this.instrumentState.faixas.length) {
        var faixaQuery = ''+this.$route.query.faixa

        var temDadosFaixaQuery = this.instrumentState
          .faixas
          .filter((f) => f.CodigoFaixaModelo === faixaQuery)
          .length
        ;

        if (faixaQuery && temDadosFaixaQuery) {
          this.faixaSelecionada = faixaQuery
        } else {
          this.faixaSelecionada = this.instrumentState.faixas[0].CodigoFaixaModelo
        }
      }
    }
  },
  computed: {
    observacaoFaixa () {
      if (!this.configDaFaixaList.length) return
      return this.configDaFaixaList
        .filter((item) => item.observacao)
        .map((item) => {
          let obj = {}
          obj['observacao'] = item.observacao
          obj['autor'] = item.autor
          obj['data'] = moment(item.timestamp).format("DD/MM/YY")
          return obj
        })[0]
    },
    ocultarConformidade () { // TODO: Verificar
      return false
    },
    textoAnalise () {
      return this.ehNovaExatidao ? 'Nova Incerteza' : 'EMA'
    },
    colunas () {

      var res = [
        {
          ////w: this.modoCompacto ? null : '100',
          //w: '100'
          prop: 'ValorDoInstrumento',
          label: 'Ponto ' + this.prefixoUnidadeParentesesX
        },
        {
          //w: '100'
          prop: 'ResultadoMedicao',
          label: 'Erro ' + this.prefixoUnidadeParentesesY
        },
        {
          //w: '100'
          prop: 'IncertExpandidaUsada',
          label: 'U ' + this.prefixoUnidadeParentesesY
        },
        {
          //w: '100'
          prop: 'tol',// se fir `analise`, pega area verde, `tol` pega a area vermelha
          label: this.textoAnalise + ' ' + this.prefixoUnidadeParentesesY
        }
      ]

      if (!this.ocultarConformidade) {
        res = res.concat({
          //w: '130'
          prop: 'pontoConforme',
          label: 'Conformidade'
        })
      }

      /*const nSeries = _.unionBy(
        this.resultadoAnalisesFlattenDeep, 'nomeSerie')
        .length
      ;*/

      if (this.nSeries > 1) {
        res = ([{
          ////w: this.modoCompacto ? null : '80'
          //w: '80'
          prop: 'nomeSerie',
          label: 'Série'
        }].concat(res))
      }

      return res  
    },
    dadosTabela () {
      const nomesColunas = this.colunas.map((col) => col.prop)

      var res = this.resultadoAnalisesFlattenDeep.map((res) => {
        var obj = {}
        nomesColunas.map((nome) => {
          const value = res[nome]
          if (_.isNumber(value)) {
            obj[nome] = fnSignformatter(value)
          }
          // Analises onde é retornado os limites superior 
          // e inferior em de um array
          if (_.isArray(value)) {
            obj[nome] = (fnSignformatter(Math.abs(value[0])))
          }
          if (_.isString(value)) {
            obj[nome] = value
          }
          if (_.isBoolean(value)) {
            obj[nome] = value ? true : false
          }
        })
        return obj
      })
      return res
    },
    prefixoUnidadeRes () {
      if (this.formatoFormula === 'al') {
        return this.dadosFaixa.Unidade
      }
      return this.prefixoUnidade
    },
    textoValorCorrigido () {
      return this.analiseFaixa.aplicarCorrecao ? 'valor corrigido: ' : ''
    },
    textoInc () {
      return this.resultadosPontoTeste.map((res) => {
        return this.pegaTextoRegressaoParaTipo('regInc', res[1])
      })
    },
    textoCorr () {
      return this.resultadosPontoTeste.map((res) => {
        return this.pegaTextoRegressaoParaTipo('regCorr', res[1])
      })
    },
    tamCorr () {
      return this.ehNovaExatidao ? 12 : 24
    },
    resultado2fmt () {
      return this.resultadosPontoTeste.map((res) => {
        if (this.ehNovaExatidao) {
          return '(' + res[2].replace(/\./g, ',') + ')'
        } else {
          return res[2].split(' ')[0].replace(/\./g, ',')
        }

      })
    },
    ehNovaExatidao () {
      return this.analiseFaixa.lhs !== 'ema' && this.analiseFaixa.lhs !== 'tol'
    },
    /**
    
    Regressao do ponto

    */
    equacaoResultadoAnalises () {
      if (!this.resultadoAnalises || !this.toleranciaCalculada) return
      var tol = this.toleranciaCalculada
      return this.resultadoAnalises.map((s, s_i) => {
        var obj = {}
        obj.CodigoFaixaModelo = s[0].CodigoFaixaModelo
        obj.nomeSerie = s[0].nomeSerie
        const dataInc = s.map((p, p_i) => [p.ValorDoInstrumento, tol[s_i][p_i][1]])
        const regInc = regressao(dataInc)

        const dataCorr = s.map((p) => [p.ValorDoInstrumento, -p.ResultadoMedicao])
        const regCorr = regressao(dataCorr)
        
        const res = _.extend(obj, {regInc: regInc, regCorr: regCorr} )
        return res
        ;
      })
    },
    resultadosPontoTeste () {
      if (!this.equacaoResultadoAnalises) return
      var res = []
      this.equacaoResultadoAnalises.map((s, si) => {
        var valorDeTeste = parseFloat(this.valorDeTeste)
        
        const arrInc = s['regInc'].equacaoArr
        const arrCorr = s['regCorr'].equacaoArr

        var regreInc, regreCorr
        regreInc = fnRegreArray(arrInc, valorDeTeste)
        regreCorr = fnRegreArray(arrCorr, valorDeTeste)

        // computa valor
        let inc = regreInc[0] * valorDeTeste + regreInc[1]
        
        var val
        if ((typeof valorDeTeste !== 'number') || isNaN(valorDeTeste)) {
          val = 0.0
        } else {
          if (this.analiseFaixa.aplicarCorrecao) {
            val = (valorDeTeste +
              regreCorr[0] *
              valorDeTeste +
              regreCorr[1])
              .toString()
            ;
          } else {
            val = this.valorDeTeste
          }
        }
        
        if (inc !== Infinity) {
          var incFmt
          if (inc <= 0) {
            incFmt = '0'
          } else {
            incFmt = fnSignformatter(inc)
          }

          let incFmtSplit = incFmt.split('.')

          // numero casas decimais do valor
          var nDecimalVal
          if (incFmtSplit.length === 2) {
            nDecimalVal = incFmtSplit[1].length
          } else {
            nDecimalVal = 0
          }
          
          res.push([
            this.seriesColors[si],
            s.nomeSerie,
            (parseFloat(val)).toFixed(nDecimalVal) +
            ' ± ' +
            incFmt]
            )
          ;
        } else {
          res.push([this.seriesColors[si], s.nomeSerie, 'Infinito'])
        }
      })
      return res
    },



    pontosDaSerieSelecionada () {
      return this.pontosExistenteParaCadaSerie[this.histSerieSel]
    },
    ehPrimeiroPontoDoHistorico () {
      return this.nomesDasSeries[0] === this.histSerieSel &&
        parseFloat(this.histPontoSel) === this.pontosDaSerieSelecionada[0]
      ;
    },
    ehUltimoPontoDoHistorico () {
      return this.nomesDasSeries[this.nomesDasSeries.length-1] === this.histSerieSel &&
        parseFloat(this.histPontoSel) === this.pontosDaSerieSelecionada[this.pontosDaSerieSelecionada.length - 1]
      ;
    },    
    mudancaDeHist () {
      return ''+this.histSerieSel+'___'+this.histPontoSel+'___'+this.faixaSelecionada
    },
    seriesFaixaAgrupadas () {
      return _.groupBy(this.seriesFaixa, 'nomeSerie')
    },
    nSeries () {
      return this.nomesDasSeries.length
    },
    nomesDasSeries () {
      return Object.keys(this.seriesFaixaAgrupadas)
    },
    pontosExistenteParaCadaSerie () {
      var res = {}
      this.nomesDasSeries.map((nomeSerie) => {
        var poltosVal = []
        this.seriesFaixaAgrupadas[nomeSerie].map((item) => {
          poltosVal = poltosVal.concat(item.data.Valor)
        })
        res[nomeSerie] = _.uniq(poltosVal)
      })
      return res
    },
    serieHist () {
      var serie = {
        name: 'Tendência',
        id: 'Historico',
        yAxis: 0,
        type: 'line'
      }
      serie.data = this.historicoDoPontoNaoNulo.map( (data) => {
        return [
          fnPegaDataUTCNum(data.HoraInicial),
          data.ResultadoMedicao
        ]
      })

      return serie
    },
    serieIncertezaHist () {

      var serie = {
        whiskerLength: 10,
        name: 'Incerteza',
        yAxis: 0,
        //linkedTo: 'Historico',
        type: 'errorbar'
      }
      serie.data = this.historicoDoPontoNaoNulo.map( (data) => {
        const U = data.IncertExpandidaUsada
        const ResultadoMedicao = data.ResultadoMedicao

        var IncertezaInferior
        var IncertezaSuperior

        if (ResultadoMedicao !== null) {
          IncertezaInferior = ResultadoMedicao - U
          IncertezaSuperior = ResultadoMedicao + U
        } else {
          IncertezaInferior = null
          IncertezaSuperior = null
        }

        return [
          fnPegaDataUTCNum(data.HoraInicial),
          IncertezaInferior,
          IncertezaSuperior
        ]
      })

      return serie

    },
    resultadoAnalisesFlattenDeep () {
      return _.flattenDeep(this.resultadoAnalises)
    },
    resPontoSel () {
      return this.resultadoAnalisesFlattenDeep.filter((item) => {
        return item.Valor === parseFloat(this.histPontoSel) &&
          item.nomeSerie === this.histSerieSel
      })[0]
    },
    serieTolHist () {
      var ErroMinimoFaixa, ErroMaximoFaixa
      if (this.resPontoSel) {
        const tol = this.resPontoSel.tol
        ErroMinimoFaixa = tol[0]
        ErroMaximoFaixa = tol[1]        
      }
      
      var serie = {
        whiskerLength: 10,
        name: 'EMA',
        yAxis: 0,
        type: 'arearange',
        marker: {enabled: false},
        fillOpacity: 0,
        //linkedTo: 'Historico',
        dashStyle: 'Dash',
        lineColor: 'red',
        color: '#ff0000'
      }
      serie.data = this.historicoDoPontoNaoNulo.map( (data) => {
        if (!this.resPontoSel) {
          ErroMinimoFaixa = data.ErroMinimoFaixa
          ErroMaximoFaixa = data.ErroMaximoFaixa
        }
        const U = data.IncertExpandidaUsada

        var IncertezaInferior
        var IncertezaSuperior

        if ((ErroMinimoFaixa !== null) && (ErroMinimoFaixa !== 0)) {
          IncertezaInferior = ErroMinimoFaixa
          IncertezaSuperior = ErroMaximoFaixa
        } else {
          IncertezaInferior = null
          IncertezaSuperior = null
        }

        return [
          fnPegaDataUTCNum(data.HoraInicial),
          IncertezaInferior,
          IncertezaSuperior
        ]
      })

      this.ajustarArea(serie)
      return serie

    },
    tituloHist () {
      if (!this.pontoSel) return ''
      
      const valPonto = ''+this.pontoSel.val
      const nomeSerie = this.pontoSel.nomeSerie
      return valPonto.toString() + ' ' +
        this.prefixoUnidade + 
        ( nomeSerie !== 'Série' || nomeSerie !== '' ?
        ' (' + this.pontoSel.nomeSerie + ')' : '' )
      ;
    },
    historicoDoPontoNaoNulo () {
      if (!this.seriesFaixaAgrupadas) return []
      if (!this.histSerieSel) return []
      
      let histSerie = this.seriesFaixaAgrupadas[this.histSerieSel]
      if (!histSerie) return []

      let historicosPontos = histSerie[0].historicosPontos
      if (!historicosPontos) return []
      
      let res = historicosPontos
        .filter((x) => (x.Valor === parseFloat(this.histPontoSel)))
        .filter((x) => (x.ResultadoMedicao !== null))
        .filter((x) => (x.nomeSerie === this.histSerieSel))
      ;
      res = _.sortBy(res, (x) => fnPegaDataUTCNum(x.HoraInicial))
      return res
    },
    /*tickPositionsComp () {
      // Pega o item que representa a data
      const res = this.serieHist.data.map((item) => item[0])
      return res
    },*/
    instrumentStateDataEventoSel () {
      if (!this.$route.query.evento) return this.instrumentState.data
      var data = {}
      Object.keys(this.instrumentState.data).map((k) => {
        if (k === 'seriesDenormRes') {
          data[k] = this.seriesFaixaEvento
        } else if (k === 'config') {
          data[k] = this.configDaFaixaListEvento
        } else {
          data[k] = this.instrumentState.data[k]
        }
      })
      return data
    },
    eventoTimeStamp () {
      if (!this.$route.query.evento) return Infinity
      // multiplica por 1000 para converter em ms, e soma 1000 para compensar a perda de 
      // da informação dos milisegundos. Para não ser necessario, incluir a 
      // informação de milisegundos na url
      return (moment(this.$route.query.evento, 'DD-MM-YYYY-HH-mm-ss').unix())*1000+1000
    },
    configDaFaixaList () {
      return this.instrumentState
        .data
        .config
        .filter((item) => {return item.analise && (item.analise[this.faixaSelecionada] || item.analise.global)})
      ;
    },
    configDaFaixaListEvento () {
      return this.configDaFaixaList.filter((c) => c.timestamp <= this.eventoTimeStamp)
    },
    eventosDaFaixa () {
      var eventos = []
      var certificados = {}
      this.seriesFaixa.map((s) => {
        if (!certificados[s.Certificado]) {
          eventos.push({
            tipo: 'calibração',
            data: moment(s.HoraInicial).unix()*1000,
            dataHuman: moment(s.HoraInicial).format('DD/MM/YYYY')
          })
          certificados[s.Certificado] = true
        }
      })
      
      this.configDaFaixaList.map((item) => {
        eventos.push({
          tipo: 'análise',
          data: item.timestamp,
          dataHuman: moment(item.timestamp).format('DD/MM/YYYY')
        })
      })
      return _.reverse(_.sortBy(eventos, 'data'))
    },
    dataFmt () {
      const dataStr = this.ultimoCertFxSel.hora

      if (!dataStr) return ''

      return moment(dataStr)
        .format("DD/MM/YY")
      ;
    },
    ultimoCertFxSel () {
      if (!this.seriesFaixaEvento.length) return {certificado: null, hora: null}
      return {
        certificado: this.seriesFaixaEvento[0].Certificado,
        hora: this.seriesFaixaEvento[0].HoraInicial
      }
    },    
    prefixoUnidade () {
      if (!this.seriesFaixaEvento.length) return ''
      var sf = this.seriesFaixaEvento[0]
      return sf.Prefixo + sf.Unidade
    },
    prefixoUnidadeParenteses () {
      if (this.prefixoUnidade !== '') {
        return '('+this.prefixoUnidade+')'
      }
      return ''
    },
    prefixoUnidadeParentesesX () {
      if (this.respFreq) {
        return '(Hz)'
      }
      return this.prefixoUnidadeParenteses
    },
    prefixoUnidadeParentesesY () {
      return this.prefixoUnidadeParenteses
    },
    
    /**
    Propriedades computadas relacionadas exclusivamente ao gráfico de análise da faixa
    */

    analisesDisponiveis () {
      return Object.keys(this.instrumentState.funcoes).map((item) => {
        return {
          // Muda texto para Personalizado quando for tol, pois fica mais intuitivo para o usuario
          desc: item === 'tol' ? 'Personalizado' : this.instrumentState.funcoes[item].desc,
          nome: item
        }
      })
    },
    titulo () {
      if (!this.faixaSelecionada) return null
      if (this.seriesFaixaEvento.length) return this.seriesFaixaEvento[0].DescFaixa
    },
    podeTerRespFreq () {
      return this.seriesFaixaEvento
        .map((s) => SI.parse(s.nomeSerie))
        .reduce((acc, curr) => ((curr.number >= 0) && 
          //curr.prefix && 
          (_.trim(curr.unit) === 'Hz')) && acc, true
        )
      ;
    },
    seriesGrafico () {
      const series = this.dadosFaixaFmt.series.map( (serie, serie_i) => {
        var res = {}
        var resMedUsado
        res.name = serie.nome
        res.id = serie.nome
        res.data = []
        for (var i = 0; i < serie.data.ResultadoMedicao.length; i++) {
          resMedUsado = this.analiseFaixa.aplicarCorrecao ? 0 : serie.data.ResultadoMedicao[i]
          res.data.push([
            serie.data.ValorDoInstrumento[i],
            resMedUsado
          ])
        }
        res.yAxis = 0
        res.type = 'line'
        res.color = this.seriesColors[serie_i]
        return res
      })
      return series
    },
    seriesIncerteza () {
      const series =  this.dadosFaixaFmt.series.map( (serie) => {
        var res = Object({})
        var resMedUsado
        res.name = serie.nome + ' (Incerteza)'
        //res.linkedTo = serie.nome
        res.data = []
        for (var i = 0; i < serie.data.ResultadoMedicao.length; i++) {
          resMedUsado = this.analiseFaixa.aplicarCorrecao ? 0 : serie.data.ResultadoMedicao[i]
          res.data.push([
            serie.data.ValorDoInstrumento[i],
            resMedUsado - serie.data.IncertExpandidaUsada[i],
            resMedUsado + serie.data.IncertExpandidaUsada[i]
          ])
        }
        res.type = 'errorbar'
        res.whiskerLength = 10
        return res
      })
      return series
    },
    seriesTol () {
      const existeAnaliseDeTol = !!this.resSeriesFaixaSelFmt.length
      if(!existeAnaliseDeTol) return null
      const series =  this.dadosFaixaFmt.series.map( (serie, serie_i) => {

        var res = Object({})
        //res.linkedTo = serie.nome
        res.dashStyle = 'Dash'
        res.lineColor = 'red'
        res.name = serie.nome + ' (EMA)'
        res.id = res.name
        //res.lineWidth = 0
        res.data = this.resSeriesFaixaSelFmt[serie_i].map( (p) => 
          [p.ValorDoInstrumento].concat(p.tol[0] === null ? [undefined, undefined] : p.tol)
        )

        res.marker = {enabled: false}
        this.ajustarArea(res)
        res.color = '#ff0000'
        //res.color = seriesColors[serie_i]
        res.type = 'arearange'
        res.fillOpacity = 0
        return res
      })
      // TODO: Testar isto. Serve para unificar os emas?
      if (this.analiseAtiva === 'criterioAceitacao') {
        if (this.analiseFaixa.lhs !== 'ema') {
          let dadosLimiteUnificado = _.clone(series[0])

          dadosLimiteUnificado.data = _.sortBy(
            _.flatten(series
              .map((s) => s.data)
            ), (p) => p[0])
          ;
          //dadosLimiteUnificado.name = 'Limite'
          dadosLimiteUnificado.id = dadosLimiteUnificado.name
          return [dadosLimiteUnificado]
        }
      }
      
      return series
    },
    seriesResultadoAnalises () {
      const series =  this.dadosFaixaFmt.series.map( (serie, serie_i) => {

        var res = {}
        res.name = serie.nome + ' (Análise)'
        res.linkedTo = serie.nome
        res.data = []

        for (var i = 0; i < serie.data.ResultadoMedicao.length; i++) {
          res.data.push([
            serie.data.ValorDoInstrumento[i],
            this.resSeriesFaixaSelFmt[serie_i][i].analise[0],
            this.resSeriesFaixaSelFmt[serie_i][i].analise[1]
          ])
        }

        this.ajustarArea(res)
        
        res.marker = {enabled: false}
        res.type = 'arearange'
        res.dashStyle = 'Dot'
        res.color = this.seriesColors[serie_i]
        res.fillOpacity = 0.15
        return res
      })
      return series
    },
    flattenSeries () {
      let res = [this.seriesGrafico
          ,this.seriesResultadoAnalises
          ,this.seriesTol
          ,this.seriesIncerteza
        ]

        res = _.flatten(res)
        res = _.compact(res)
        res = res.filter( (serie) => {
          const pontosNulosArr = serie.data.map((p) => p[1] === null)
          return !_.filter(pontosNulosArr, (p) => p).length
        })
        res = _.sortBy(res, (serie) => serie.name)
      ;
      return res
    },
    faixas () {
      if (!this.instrumentState.faixas.length) {
        return null
      }
      return this.instrumentState.faixas
    },
    dadosFaixaFmt () {
      if (this.respFreq && this.podeTerRespFreq) {
        var df = []
        for (var i = 0; i < this.dadosFaixa.series.length; i++) {
          let serie = this.dadosFaixa.series[i]
          for (var j = 0; j < serie.data.Valor.length; j++) {
            let obj = Object.create({})
            _.keys(serie.data).map((key) => {
              obj[key] = serie.data[key][j]
            })
            obj.nome = serie.nome
            obj.cod = serie.cod
            obj.sortval = serie.sortval
            df.push(obj)
          }
        }
        
        var groupedByVal = _.groupBy(df, 'Valor')
        var respFreqSeries = _.keys(groupedByVal).map((val) => {
          var serie = groupedByVal[val]
          var serieData = {
            cod: 'respFreq_'+val,
            nome: val+' '+this.prefixoUnidade,
            sortval: null,
            data: {}
          }
          var keys = ['ErroMaximoFaixa',
            'ErroMinimoFaixa',
            'IncertExpandidaUsada',
            'ResultadoMedicao',
            'Valor',
            'ValorDoInstrumento',
            'ValorDoPadrao',
            'fatork'
          ]
          keys.map((key) => {
            serieData.data[key] = []
            for (var i = 0; i < serie.length; i++) {
              if (key === 'ValorDoInstrumento') {
                serieData.data[key].push(SI.parse(serie[i]['nome']).number)
              } else {
                serieData.data[key].push(serie[i][key])
              }
            }
          })
          return serieData
        })
        
        return {series: respFreqSeries}
      }
      return this.dadosFaixa
    },
    resSeriesFaixaSelFmt () {
      if (this.respFreq && this.podeTerRespFreq) {
        var respFreqFaixaSel = _.cloneDeep(this.resultadoAnalises)

        respFreqFaixaSel = _.flatten(respFreqFaixaSel).map((p) => {
          p.ValorDoInstrumento = SI.parse(p.nomeSerie).number
          p.cod = 'respFreq_'+p.Valor
          return p
        })
        let grouped = _.groupBy(respFreqFaixaSel, 'cod')
        
        // itera na mesma ordem das séries dos dados,
        // garantindo os resultados das analises correspondentes
        return this.dadosFaixaFmt.series.map((s) => grouped[s.cod])
      }
      return this.resultadoAnalises
    },
    series () {
      return this.instrumentState.data.seriesDenormRes
    },
    seriesFaixa () {
      return this.series.filter((item) => item.CodigoFaixaModelo === this.faixaSelecionada)
    },
    seriesFaixaEvento () {
      var res = this.seriesFaixa.filter((s) => moment(s.HoraInicial).unix()*1000 <= this.eventoTimeStamp)
      return res
    },
    analiseAtiva () {
      var res = this.instrumentState.funcoes[this.analiseFaixa.lhs].tipoAnalise
      return res
    }
  }
}
</script>

<style scoped>
</style>
